import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Login from './views/Auth/Login';
import Register from './views/Auth/Register';
import NavBar from './components/NavBar/NavBar';
import TopBar from './components/TopBar/TopBar';
import Orders from './views/Orders/Orders';
import OrderDetails from './views/OrderDetails/OrderDetails';
import Categories from './views/Categories/Categories';
import Products from './views/Admin/NewPharmacyProduct';
import NewProduct from './views/Products/AddProductPharmacies';
import Profile from './views/Profile/Profile';
import Schedule from './views/Profile/Schedule';
import Drivers from './views/Drivers/Drivers';
import DriverDetails from './views/DriverDetails/DriverDetails';
import AdminOrders from './views/Admin/Orders';
import AdminPharmacies from './views/Admin/Pharmacies';
import AdminPharmacyDetails from './views/Admin/PharmacyDetails';
import AdminPharmacyProducts from './views/Admin/PharmacyProducts';
import AdminPharmacyNewProduct from './views/Products/AddProductPharmacies';
import AdminPharmacyCategories from './views/Admin/PharmacyCategories';
import { PharmacyCreateProduct } from './views/Admin/PharmacyCreateProduct';
import CategoriesList from './views/Admin/Categories.jsx';
import ReportOrder from './views/Admin/ReportOrder'
import { Provider } from "react-redux"
import { store } from './store/store';
import Ads from './views/Admin/Ads';
import AdsPharmacy from './views/ads/Ads'
import Plans from './views/Admin/Plans'
import Billing from './views/Billing/Billing'
import AdsPlansTab from './views/Admin/AdsPlansTab';
import DriverAdminTap from './views/Admin/drivers/DriverAdminTap';
import ReportDriverOders from './views/Admin/reports/ReportDriver';

import Terms from './views/Admin/Terms';
import Question from './views/Admin/Questions';
import Politica from './views/Admin/Politica'


const { Content } = Layout;

const Router = () => {
	const location = useLocation();
	const path = location.pathname;

	if (['/', '/login', '/register', '/termsandconditions', '/policy', '/frequentquestions'].includes(path)) {
		return (
			<Routes>
				<Route path='/' element={<Login />} />
				<Route path='/login' element={<Login />} />
				<Route path='/register' element={<Register />} />
				<Route exact path='/termsandconditions' element={<Terms />} />
				<Route exact path='/frequentquestions' element={<Question />} />
				<Route exact path='/policy' element={<Politica />} />
			</Routes>
		);
	}

	return (
		<Provider store={store}>
			
			<Layout style={{ minHeight: '100vh' }}>
				<NavBar />
				<Layout className='site-layout'>
					<TopBar />
					<Content style={{ margin: 20, padding: 20, height: '90%', backgroundColor: '#fff', borderRadius: 10 }}>
						<Routes>
							<Route exact path='/Billing' element={<Billing />} />
							<Route exact path='/products' element={<Products />} />
							<Route exact path='/newProduct' element={<NewProduct />} />
							<Route exact path='/orders' element={<Orders />} />
							<Route exact path='/orderDetails/:id' element={<OrderDetails />} />
							<Route exact path='/categories' element={<Categories />} />
							<Route exact path='/profile' element={<Profile />} />
							<Route exact path='/drivers' element={<Drivers />} />
							<Route exact path='/driverDetails/:id' element={<DriverDetails />} />
							<Route exact path='/schedule' element={<Schedule />} />
							<Route exact path='/admin/orders' element={<AdminOrders />} />
							<Route exact path='/admin/pharmacies' element={<AdminPharmacies />} />
							<Route exact path='/admin/pharmacyDetails/:id' element={<AdminPharmacyDetails />} />
							<Route exact path='/admin/pharmacyProducts/:id' element={<Products />} />
							<Route exact path='/admin/pharmacyNewProduct/:id' element={<AdminPharmacyNewProduct />} />
							<Route exact path='/admin/pharmacyCreateNewProduct' element={<PharmacyCreateProduct />} />
							<Route exact path='/admin/ads' element={<AdsPlansTab />} />
							<Route exact path='/pharmacy/ads' element={<AdsPharmacy />} />
							<Route exact path='/admin/plans' element={<Plans />} />
							<Route exact path='/views/Admin/create/Categories' element={<CategoriesList />} />
							<Route exact path='/views/Admin/reportpharmacies' element={<ReportOrder />} />
							<Route exact path='/admin/pharmacyCategories/:id' element={<AdminPharmacyCategories />} />
							<Route exact path='/admin/drivers' element={<DriverAdminTap />} />
							<Route exact path='/views/Admin/reports/ReportDriver' element={<ReportDriverOders />} />
							

						</Routes>
					</Content>
				</Layout>
				


			</Layout>
		
		</Provider>
		
	);
};

export default Router;
